import { render } from "./FeaturedCruiseShelf.vue?vue&type=template&id=6b35ed5b&scoped=true"
import script from "./FeaturedCruiseShelf.vue?vue&type=script&lang=js"
export * from "./FeaturedCruiseShelf.vue?vue&type=script&lang=js"

import "./FeaturedCruiseShelf.vue?vue&type=style&index=0&id=6b35ed5b&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6b35ed5b"]])

export default __exports__